// extracted by mini-css-extract-plugin
module.exports = {"section-header-wrapper":"SectionHeading_section-header-wrapper__bbxEu","section-header":"SectionHeading_section-header__LAf_P"};